module.exports = __webpack_public_path__ + "img/dg2.58d3452d.jpg";